import { Link } from "react-router-dom";
import { Instagram, Facebook, Linkedin, Youtube, Mail, Phone, MapPin } from "lucide-react";
import { useState } from "react";
import { api, formatErr } from "../../lib/api";
import { toast } from "sonner";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      await api.post("/newsletter", { email });
      toast.success("Subscribed! Welcome to the CFT insider list.");
      setEmail("");
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail) || "Subscription failed");
    } finally { setBusy(false); }
  };

  return (
    <footer data-testid="site-footer" className="text-[#0A1128] relative overflow-hidden border-t border-zinc-200"
      style={{ background: "linear-gradient(135deg, #fff0f6 0%, #fff7f0 30%, #f0fbff 65%, #f5f0ff 100%)" }}>
      <div className="absolute -top-32 -left-32 w-96 h-96 rounded-full bg-[#FF007F]/10 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-32 -right-32 w-96 h-96 rounded-full bg-[#00BFE0]/10 blur-3xl pointer-events-none" />

      <div className="relative container mx-auto px-4 pt-20 pb-10">
        <div className="grid lg:grid-cols-4 gap-12 mb-12">
          <div className="lg:col-span-2">
            <div className="mb-4">
              <img src="/logo.gif" alt="CFT Creations" className="h-14 w-auto" />
            </div>
            <p className="text-zinc-600 font-medium max-w-md mb-6 leading-relaxed">
              A complete creative & digital growth partner. Branding, advertising,
              production, studio rentals, and digital growth — all under one roof.
            </p>
            <p className="text-sm text-zinc-600 mb-6 font-mono font-semibold">Your Brand. Our Strategy.</p>
            <form onSubmit={subscribe} className="flex max-w-sm" data-testid="newsletter-form">
              <input
                value={email} onChange={(e) => setEmail(e.target.value)} type="email" required
                placeholder="you@brand.com" data-testid="newsletter-email"
                className="flex-1 px-4 py-3 rounded-l-full bg-zinc-100 border border-zinc-200 text-sm focus:outline-none focus:border-[#00BFE0]"
              />
              <button type="submit" disabled={busy} data-testid="newsletter-submit"
                className="px-5 py-3 rounded-r-full bg-gradient-brand text-white text-sm font-bold disabled:opacity-50">
                {busy ? "..." : "Join"}
              </button>
            </form>
          </div>

          <div>
            <h4 className="font-display font-bold text-lg mb-4">Explore</h4>
            <ul className="space-y-2 text-sm text-zinc-700 font-semibold">
              <li><Link to="/services" className="hover:text-[#FF007F]">Services</Link></li>
              <li><Link to="/studios" className="hover:text-[#FF007F]">Studio Rental</Link></li>
              <li><Link to="/props" className="hover:text-[#FF007F]">Props Rental</Link></li>
              <li><Link to="/portfolio" className="hover:text-[#FF007F]">Portfolio</Link></li>
              <li><Link to="/case-studies" className="hover:text-[#FF007F]">Case Studies</Link></li>
              <li><Link to="/blog" className="hover:text-[#FF007F]">Blog</Link></li>
              <li><Link to="/quote" className="hover:text-[#FF007F]">AI Quote Generator</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-bold text-lg mb-4">Get in touch</h4>
            <ul className="space-y-3 text-sm text-zinc-700 font-semibold">
              <li className="flex items-center gap-2"><Phone className="w-4 h-4" /> 9566115611</li>
              <li className="flex items-center gap-2"><Mail className="w-4 h-4" /> info@cftcreations.com</li>
              <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5" /> D.No 31, Arappalayam Cross Road, Madurai, Tamil Nadu 625016, India</li>
            </ul>
            <div className="flex gap-3 mt-5">
              <a href="https://instagram.com/cftcreations" aria-label="Instagram"
                className="w-9 h-9 grid place-items-center rounded-full bg-zinc-100 hover:bg-gradient-brand hover:text-white transition"><Instagram className="w-4 h-4" /></a>
              <a href="#" aria-label="Facebook"
                className="w-9 h-9 grid place-items-center rounded-full bg-zinc-100 hover:bg-gradient-brand hover:text-white transition"><Facebook className="w-4 h-4" /></a>
              <a href="#" aria-label="LinkedIn"
                className="w-9 h-9 grid place-items-center rounded-full bg-zinc-100 hover:bg-gradient-brand hover:text-white transition"><Linkedin className="w-4 h-4" /></a>
              <a href="#" aria-label="YouTube"
                className="w-9 h-9 grid place-items-center rounded-full bg-zinc-100 hover:bg-gradient-brand hover:text-white transition"><Youtube className="w-4 h-4" /></a>
            </div>
          </div>
        </div>

        <div className="border-t border-zinc-200 pt-6 flex flex-col md:flex-row gap-4 items-center justify-between text-xs text-zinc-600 font-semibold">
          <div>© {new Date().getFullYear()} CFT Creations. Powered by Victinet IT Solutions Pvt. Ltd.</div>
          <div className="flex gap-5">
            <Link to="/careers" className="hover:text-[#FF007F]">Careers</Link>
            <Link to="/privacy" className="hover:text-[#FF007F]">Privacy</Link>
            <Link to="/terms" className="hover:text-[#FF007F]">Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
